module.exports = __webpack_public_path__ + "static/Benson.d38e78f4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/team/Benson.jpg
// module id = 1290
// module chunks = 137408898365125